export function isStaticData(data) {
  return data.children?.length > 0;
}